export default __webpack_public_path__ + "static/media/iDocFont-20.098ab869.svg";